import { RoutineType, WorkspaceAsset, WorkspaceRoutine } from '@gripp/shared-logic';

export const getCounterRoutinesForOnInterval = (
  workspaceAsset: WorkspaceAsset
): WorkspaceRoutine[] => {
  const counterTypeRoutines =
    workspaceAsset.routines?.filter(
      (routine) => routine.type === RoutineType.Counter
    ) || [];

  const counterRoutinesWithState = counterTypeRoutines.map((routine) => {
    const routineId = routine.id;
    const state = workspaceAsset.routineState?.find(
      (s) => routineId === s.workspaceRoutineId
    );
    return { ...routine, state: state?.state };
  });

  return counterRoutinesWithState;
};
